import React, { useState } from 'react';
import Icon from './AppIcon';

const BADGE_CONFIG = {
  verified_seller: {
    label: 'Verified Seller',
    icon: 'BadgeCheck',
    color: 'text-primary',
    bg: 'bg-primary/10',
    border: 'border-primary/20',
    description: 'Completed at least 1 successful sale'
  },
  top_rated_seller: {
    label: 'Top Rated',
    icon: 'Star',
    color: 'text-yellow-400',
    bg: 'bg-yellow-400/10',
    border: 'border-yellow-400/20',
    description: '4.5+ rating with 10+ sales'
  },
  trusted_buyer: {
    label: 'Trusted Buyer',
    icon: 'ShieldCheck',
    color: 'text-success',
    bg: 'bg-success/10',
    border: 'border-success/20',
    description: '4.0+ buyer rating with 5+ purchases'
  },
  power_seller: {
    label: 'Power Seller',
    icon: 'Zap',
    color: 'text-warning',
    bg: 'bg-warning/10',
    border: 'border-warning/20',
    description: '50+ completed sales'
  },
  fast_shipper: {
    label: 'Fast Shipper',
    icon: 'Truck',
    color: 'text-blue-400',
    bg: 'bg-blue-400/10',
    border: 'border-blue-400/20',
    description: 'Consistently ships within 24 hours'
  },
  responsive_seller: {
    label: 'Responsive',
    icon: 'MessageCircle',
    color: 'text-purple-400',
    bg: 'bg-purple-400/10',
    border: 'border-purple-400/20',
    description: 'Responds to messages within 2 hours'
  },
  veteran_trader: {
    label: 'Veteran Trader',
    icon: 'Trophy',
    color: 'text-orange-400',
    bg: 'bg-orange-400/10',
    border: 'border-orange-400/20',
    description: '100+ total trades completed'
  },
  elite_member: {
    label: 'Elite Member',
    icon: 'Crown',
    color: 'text-pink-400',
    bg: 'bg-pink-400/10',
    border: 'border-pink-400/20',
    description: 'Elite membership tier'
  }
};

const TrustBadge = ({ badgeType, size = 'sm', showTooltip = true }) => {
  const [tooltipVisible, setTooltipVisible] = React.useState(false);
  const config = BADGE_CONFIG?.[badgeType];

  if (!config) return null;

  const sizeClasses = {
    xs: 'px-1.5 py-0.5 text-xs gap-1',
    sm: 'px-2 py-1 text-xs gap-1.5',
    md: 'px-3 py-1.5 text-sm gap-2',
    lg: 'px-4 py-2 text-base gap-2'
  };

  const iconSizes = { xs: 10, sm: 12, md: 14, lg: 16 };

  return (
    <div className="relative inline-block">
      <div
        className={`inline-flex items-center rounded-full border font-medium ${sizeClasses?.[size]} ${config?.bg} ${config?.color} ${config?.border} cursor-default`}
        onMouseEnter={() => showTooltip && setTooltipVisible(true)}
        onMouseLeave={() => setTooltipVisible(false)}
      >
        <Icon name={config?.icon} size={iconSizes?.[size]} />
        <span>{config?.label}</span>
      </div>
      {showTooltip && tooltipVisible && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-50 w-48 bg-popover border border-border rounded-lg p-2 shadow-lg">
          <p className="text-xs text-muted-foreground text-center">{config?.description}</p>
          <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-border" />
        </div>
      )}
    </div>
  );
};

export { BADGE_CONFIG };
export default TrustBadge;
